
import React from 'react';
import styles from './_phone-number-grid-cell.module.scss';
import { GridCellProps } from '@progress/kendo-react-grid';
import { formatPhoneNumber } from '@amsanalytics/react-shared-library';

export const PhoneNumberCell = (props: GridCellProps) => {
  return (
    <td style={{ cursor: `pointer`, pointerEvents: `all`, paddingLeft: '12px', paddingTop: '1​2px', paddingBottom: '0px', paddingRight: '0px' }}>
      {props.dataItem.mobilePhone && formatPhoneNumber(props.dataItem.mobilePhone)}
    </td>
  );
};
